import React from 'react'
import ScrollableDealModule from '@/components/ScrollableDealModule'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import HOTELS_DEAL_MODULE_CONTENT from './constants'

function HotelsDealModules() {
  return (
    <LayoutComponentWrapper>
      <ScrollableDealModule
        content={HOTELS_DEAL_MODULE_CONTENT}
        isUsingNavArrows={false}
        handleNavOnClick={(href: string) => window.open(href)}
        isUsingPriceType={false}
        isUsingPricePrefix
        isOpaque={false}
      />
    </LayoutComponentWrapper>
  )
}
export default HotelsDealModules
